import React, { useCallback, useState, useEffect } from 'react';
import RailplusModal from "./RailplusModal";
import { clickRailplusEventWeb } from 'common/appInterface';

const RailplusTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [isModal, setModal] = useState(false);
  const [trafficCardNo, setTrafficCardNo] = useState("");
  const [trafficBalance, setTrafficBalance] = useState("");
  const [transactionList, setTransactionList] = useState("");

  const closeModal = useCallback(() => {
    setModal(false);
  }, []);

  // clickRailplusEvent_Web 처리 (WEB > APP)
  const clickRailplusEvent = useCallback(() => {
    clickRailplusEventWeb("");

    setModal(true);
  }, []);

  // completedRailplus_App 처리 (APP > WEB)
  const completedRailplusApp = useCallback((event) => {
    closeModal(true);
    setTrafficCardNo(event.detail.trafficCardNo);
    setTrafficBalance(event.detail.trafficBalance);
    setTransactionList(event.detail.transactionList);
    alert("completedRailplus_App catch...");
  }, [closeModal]);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callback);
    return () => document.removeEventListener("backpress", callback);
  }, [callback]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">clickRailplusEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={clickRailplusEvent}><span>clickRailplusEvent_Web Call</span></button>
            </div>
          </div>
        </div>
        {isModal &&
          <RailplusModal callbackEvent={completedRailplusApp} onClose={closeModal}></RailplusModal>
        }
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">completedRailplus_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={trafficCardNo} readOnly />
                <span>trafficCardNo</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={trafficBalance} readOnly />
                <span>trafficBalance</span>
              </label>
            </div>
            <div className="inputBoxTy01 mgb120"> 
              <label className="mgb20">
                <input type="text" value={transactionList} readOnly />
                <span>transactionList</span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01 mgb60" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default RailplusTest;